var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.$store.state.Dialog.confirmDialog, function(dialog) {
      return _c(
        "div",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "290" },
              model: {
                value: dialog.isConfirm,
                callback: function($$v) {
                  _vm.$set(dialog, "isConfirm", $$v)
                },
                expression: "dialog.isConfirm"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v(_vm._s(dialog.title))
                  ]),
                  _c("v-card-text", [_vm._v(_vm._s(dialog.content))]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._l(_vm.customButtonsArray(dialog), function(button) {
                        return _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color:
                                    typeof button.color !== "undefined"
                                      ? button.color
                                      : null,
                                  text: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clickCustomButton(dialog, button)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(button.text))]
                            )
                          ],
                          1
                        )
                      }),
                      dialog.customButtons == null
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "", text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.$store.commit(
                                    "CANCEL_DIALOG",
                                    dialog
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                          )
                        : _vm._e(),
                      dialog.customButtons == null
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "accent", text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.$store.commit(
                                    "ACCEPT_DIALOG",
                                    dialog
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("global.ok")))]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }